import styled from "@emotion/styled";
import { BaseCell } from "./BaseCell";
import {
  ChevronProgressSectionDown,
  ChevronProgressSectionUp,
} from "src/assets/icons";
import { GhostButton } from "src/components/Buttons";

const Container = styled(BaseCell)<{ flex: number }>`
  flex: ${(props) => props.flex};
`;

const Push = styled.div`
  content: " ";
  width: 35px;
`;

interface HeaderSortingCellProps {
  title: string;
  sortDirection: "asc" | "desc";
  onSort: () => void;
}

export const HeaderSortingCell = ({
  title,
  sortDirection,
  onSort,
}: HeaderSortingCellProps) => {
  const SortIcon =
    sortDirection === "desc"
      ? ChevronProgressSectionDown
      : ChevronProgressSectionUp;
  return (
    <Container flex={title === "Name" ? 2 : 1}>
      {title === "Name" && <Push />}
      <GhostButton onClick={onSort}>
        {title}
        <SortIcon />
      </GhostButton>
    </Container>
  );
};
